import {
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { Box, Button, Tooltip } from '@mui/material';
import { Stack } from '@mui/system';
import Iconify from '../iconify';
import { ReactNode } from 'react';

type CustomToolbarProps = {
  searchTooltipMessage?: string;
  children?: ReactNode;
  onFilterButtonClick?: () => void;
  excludeExportButton?: boolean;
  showQuickFilter?: boolean;
};

export function CustomToolbar({
  searchTooltipMessage,
  children,
  onFilterButtonClick,
  excludeExportButton = false,
  showQuickFilter = true,
}: CustomToolbarProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 1,
      }}
    >
      {!children ? (
        <>
          <Stack direction="row" spacing={1} alignItems="center">
            {showQuickFilter && (
              <GridToolbarQuickFilter
                placeholder="Pesquisar..."
                quickFilterParser={(searchInput) => searchInput.split(' ')}
              />
            )}
            {!!searchTooltipMessage && (
              <Tooltip title={searchTooltipMessage}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Iconify icon="mdi:information-outline" fontSize={18} />
                </Box>
              </Tooltip>
            )}
          </Stack>

          <Stack direction="row" spacing={0.5}>
            <GridToolbarColumnsButton />
            {onFilterButtonClick ? (
              <Button
                size="small"
                startIcon={<Iconify icon="mdi:filter-variant" />}
                onClick={onFilterButtonClick}
              >
                Filtros
              </Button>
            ) : (
              <GridToolbarFilterButton />
            )}
            <GridToolbarDensitySelector />
            {!excludeExportButton && <GridToolbarExport />}
          </Stack>
        </>
      ) : (
        children
      )}
    </Box>
  );
}
